import React from 'react';
import { Avatar, AvatarGroup, AttachedActivity, Dropdown, Link } from 'react-activity-feed';
import history from '../../auth/history';

import { humanizeTimestamp, userOrDefault } from '../../utils/activityUtils';

export default class Notification extends React.Component {
  getUsers = activities => activities.map(item => userOrDefault(item.actor));

  _getOnClickUser(actor) {
    return this.props.onClickUser ? e => this.onClickUser(e, actor) : undefined;
  }

  onClickUser = (e, actor) => {
    const { onClickUser } = this.props;
    if (onClickUser) {
      e.stopPropagation();
      return onClickUser(userOrDefault(actor));
    }
  };

  _getOnClickNotification(redirectLocation) {
    if (redirectLocation) {
      history.push(redirectLocation);
    } else {
      return this.props.onClickNotification ? this.onClickNotification : undefined;
    }
  }

  onClickNotification = e => {
    const { onClickNotification } = this.props;
    if (onClickNotification) {
      e.stopPropagation();
      return onClickNotification(this.props.activityGroup);
    }
  };

  renderAttachedActivity = latestActivity => {
    switch (latestActivity.verb) {
      case 'follow': {
        return <AttachedActivity activity={latestActivity} />;
      }
      case 'CREATE': {
        return <AttachedActivity activity={latestActivity} />;
      }
      case 'CREATE_SHOW': {
        return <AttachedActivity activity={latestActivity} />;
      }
      case 'CREATE_EPISODE': {
        return <AttachedActivity activity={latestActivity} />;
      }
      default: {
        return null;
      }
    }
  };

  render() {
    let headerText, headerSubtext;
    const { activityGroup, onMarkAsRead } = this.props;
    const activities = activityGroup.activities;
    const latestActivity = activities[0];
    const lastActor = userOrDefault(latestActivity.actor);
    let redirectLocation;

    if (activities.length) {
      headerText = lastActor.data.name;
    } else if (activities.length > 1 && activities.length < 1 + 1 + 1) {
      headerText = `${lastActor.data.name || 'Unknown'} and 1 other `;
    } else {
      headerText = `${lastActor.data.name || 'Unknown'} and ${activities.length - 1} others `;
    }

    if (latestActivity.verb === 'CREATE') {
      headerSubtext = 'created a new clipp';
      redirectLocation = `/user/${latestActivity.actor.id}`;
      // icon = HeartIcon;
    } else if (latestActivity.verb === 'CREATE_SHOW') {
      headerSubtext = 'was created';
      redirectLocation = `/${latestActivity.actor.id}`;
      // icon = HeartIcon;
    } else if (latestActivity.verb === 'CREATE_EPISODE') {
      let episodeId = latestActivity.object && latestActivity.object.split(':');
      headerSubtext = 'added a new episode';
      redirectLocation = `/e/${episodeId[1]}`;
      // icon = HeartIcon;
    } else if (latestActivity.verb === 'like') {
      headerSubtext = 'liked';
      headerSubtext += ` your ${latestActivity.object.verb}`;
      // icon = HeartIcon;
    } else if (latestActivity.verb === 'repost') {
      headerSubtext = `reposted`;
      headerSubtext += ` your ${latestActivity.object.verb}`;
      // icon = RepostIcon;
    } else if (latestActivity.verb === 'follow') {
      headerSubtext = `followed`;
      headerSubtext += ` you`;
      // icon = RepostIcon;
    } else if (latestActivity.verb === 'comment') {
      headerSubtext = `commented`;
      headerSubtext += ` on your ${latestActivity.object.verb}`;
      // icon = RepostIcon;
    }

    return (
      <div
        onClick={this._getOnClickNotification.bind(this, redirectLocation)}
        className={'raf-notification' + (activityGroup.is_read ? ' raf-notification--read' : '')}
      >
        <Avatar onClick={this._getOnClickUser(lastActor)} image={lastActor.data.profileImage} circle size={30} />
        <div className='raf-notification__content'>
          <div className='raf-notification__header'>
            <strong>{headerText}</strong> {headerSubtext}
            {!activityGroup.is_read && onMarkAsRead && (
              <Dropdown>
                <div>
                  <Link
                    onClick={e => {
                      e.stopPropagation();
                      onMarkAsRead(activityGroup);
                    }}
                  >
                    Mark&nbsp;as&nbsp;read
                  </Link>
                </div>
              </Dropdown>
            )}
          </div>
          <div>
            <small>{humanizeTimestamp(latestActivity.time)}</small>
          </div>
          {this.renderAttachedActivity(latestActivity)}
        </div>
        <div className='raf-notification__extra'>
          {activities.length > 1 && latestActivity.verb === 'follow' ? (
            <AvatarGroup
              onClickUser={this.props.onClickUser}
              avatarSize={30}
              users={this.getUsers(activities.slice(1, activities.length))}
            />
          ) : null}
        </div>
      </div>
    );
  }
}
